import { DatePipe } from '@angular/common';
import { Pipe, type PipeTransform } from '@angular/core';
import moment from 'moment';

import { MOMENT_UTC_DATETIME_FORMAT } from '@app/shared/constants/shared.constant';
import { Helpers } from '@app/shared/utils/helpers';

@Pipe({ name: 'dateFromNow', standalone: true })
export class DateFromNowPipe extends DatePipe implements PipeTransform {
    transform(value: any): any {
        if (Helpers.isValidDate(value, MOMENT_UTC_DATETIME_FORMAT) === false) {
            return value;
        }
        if (value) {
            // All dates incoming should be in UTC, and we will convert from UTC to local timezone
            return moment(moment.utc(value).local()).fromNow();
        }

        return value;
    }
}
